import ko from "knockout";
import ViewModel from "viewModels/ViewModelTyped";
import renderLinks from "util/linkRenderer";
import Icons from "enums/Icons";
interface CollapsableTextParams {
    text: ko.MaybeObservable<string>;
}

export default class CollapsableText extends ViewModel {
    public value: ko.PureComputed<string>;
    public readonly expanded: ko.Observable<boolean> = ko.observable(false);
    public readonly overflowing: ko.Observable<boolean> = ko.observable(false);
    public readonly Icons = Icons;
    private node?: HTMLElement;

    constructor({ text }: CollapsableTextParams) {
        super();
        this.value = this.pureComputed(() => renderLinks(ko.unwrap(text)));
        this.subscribe(this.value, () => {
            this.calculateOverflow();
        });
        this.onResize = this.onResize.bind(this);
    }

    koDescendantsComplete(node: HTMLElement) {
        this.node = node;
        this.calculateOverflow();
    }

    onResize() {
        const expanded = this.expanded();
        this.expanded(false);
        this.calculateOverflow();
        this.expanded(expanded);
    }

    calculateOverflow() {
        if (this.node) {
            const { scrollHeight, clientHeight } = this.node;
            this.overflowing(scrollHeight > clientHeight);
        }
    }

    toggleExpansion() {
        this.expanded(!this.expanded());
    }
}
